import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, Field, change, SubmissionError, submit } from 'redux-form'
import { UnoUtil, UnoCaptcha } from "uno-security-common"
import validate from '../validation/ForgetUserNameValidation'
import { setPage } from "../actions/index"


const renderInput = UnoUtil.inputRenderer.renderInput;
const UnoCaptchaComponent = UnoCaptcha.UnoCaptchaComponent;
const formName = "forgetusernameform";
const getSecurityHeaders = UnoUtil.security.getSecurityHeaders;

const SubmitHelper = {};
const mySubmitHandler = (values) => {
    const dispatch = SubmitHelper.dispatch;
    const messages = SubmitHelper.cmeUno.messages;
    return fetch("forgetusername/confirm", {
        method: "POST",
        headers: {
            ...getSecurityHeaders(),
            Accept: 'application/json',
            "Content-Type": 'application/json'
        },
        body: JSON.stringify(values),
        credentials: 'same-origin'
    }).then((response) => {
        if (response.ok){
            dispatch(setPage("confirm"));
        } else {
            SubmitHelper.unoCaptchaInstance.reset();
            dispatch(change(formName, "captchaResponse", null));
            if (response.status === 400){
                return response.json();
            } else {
                throw new SubmissionError({_error: messages['ForgetUserName.submit.systemError']});
            }
        }
    }).then(errorBody => {
        console.log(errorBody);
        if (errorBody){
            if (errorBody.errorCode === 'Illegal.Input'){
                throw new SubmissionError({
                    ...errorBody.data,
                    _error: messages['ForgetUserName.submit.inputError']
                });
            }
        }
    });
};

/**
 * @deprecated per E, this component is no longer used
 */
class ForgetUserNameFormImplComponent extends React.Component {

    constructor(props){
        super(props);
        this.cmeUno = props.cmeUno;
        this.dispatch = props.dispatch;
        SubmitHelper.dispatch = this.dispatch;
        SubmitHelper.cmeUno = this.cmeUno;

        this.unoCaptchaInstanceGetter = this.unoCaptchaInstanceGetter.bind(this);
        this.unoCaptchaChangeCallback = this.unoCaptchaChangeCallback.bind(this);
        this.submitFormClick = this.submitFormClick.bind(this);
    }

    unoCaptchaInstanceGetter(unoCaptchaInstance){
        this.unoCaptchaInstance = unoCaptchaInstance;
        SubmitHelper.unoCaptchaInstance = unoCaptchaInstance;
    }

    unoCaptchaChangeCallback(){
        this.dispatch(submit(formName));
    }

    submitFormClick(e){
        e.preventDefault();
        this.unoCaptchaInstance.execute();
    }


    render(){
        const {cmeUno,
            //The three props below come from redux-form
            handleSubmit,
            pristine,
            submitting,
            valid,
            error} = this.props;

        const oneThirdClassName = "required grid__col-xs-12 grid__col-sm-12 grid__col-md-4 grid__col-lg-4 hard--top hard--sides soft-half--bottom"

        return (
            <form onSubmit={handleSubmit}>
                <p>{cmeUno.messages["ForgetUserName.smartclickOnly"]}</p>
                {
                    error &&
                    <div className="alert alert--error push--top">{error}</div>
                }
                <ul className="form-fields">
                    <Field
                        name="email"
                        id="email"
                        required={true}
                        wrapperClassName={oneThirdClassName}
                        label={cmeUno.messages.email}
                        className="text-input responsive"
                        component={renderInput}
                        type="text"
                        autoFocus={true}
                    />
                    <li class="required">
                        <Field
                            disableCaptcha={cmeUno.data.unoCaptcha.disableCaptcha}
                            formName={formName}
                            siteKey={cmeUno.data.unoCaptcha.siteKey}
                            jcaptchaImage={cmeUno.data.unoCaptcha.jcaptchaImage}
                            jcaptchaLabel={cmeUno.messages.captchaResponse}
                            jcaptchaRefreshLabel={cmeUno.messages.refresh}
                            id="captchaResponse"
                            name="captchaResponse"
                            component={UnoCaptchaComponent}
                            unoCaptchaRef={this.unoCaptchaInstanceGetter}
                            changeCallback={this.unoCaptchaChangeCallback}
                        />
                    </li>
                </ul>
                <div>
                    <a id="backToLogin" href="backToLogin.action" className="btn btn--secondary push--right btn--large">{cmeUno.messages.backToLogin}</a>
                    <button type="submit"
                            className="btn btn--large"
                            disabled={pristine || !valid || submitting }
                            onClick={this.submitFormClick}
                    >
                        {
                            (submitting) &&
                            <span><i className="fa fa-spin fa-spinner" /> <span>{cmeUno.messages.processing}</span></span>
                        }
                        {! submitting && <span>{cmeUno.messages.submit}</span>}
                    </button>
                </div>
            </form>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    cmeUno: ownProps.cmeUno,
    state: state
});

const ForgetUserNameFormComponent = reduxForm({
    form: formName,
    validate: validate,
    onSubmit: mySubmitHandler
})(connect(mapStateToProps)(ForgetUserNameFormImplComponent));

export default ForgetUserNameFormComponent;